module.exports = __webpack_public_path__ + "static/css-970b93f0f37f1af926ba32a3200c0879.png";